// Generated by BUCKLESCRIPT VERSION 5.0.3, PLEASE EDIT WITH CARE
'use strict';

var App = require("./App.bs.js");
var Store = require("../store.bs.js");
var React = require("react");

function Root(Props) {
  var value = React.useReducer(Store.reducer, /* [] */0);
  return React.createElement(Store.Provider[/* make */0], {
              value: value,
              children: React.createElement(App.make, { })
            });
}

var make = Root;

exports.make = make;
/* App Not a pure module */
